/* eslint-disable import/prefer-default-export */
/* eslint-disable camelcase */

import {
  OPEN_MEETINGROOM_MODAL,
  CLOSE_MEETINGROOM_MODAL,
  OPEN_ROOMSELECT_POPUP_MODAL,
  CLOSE_ROOMSELECT_POPUP_MODAL,
  TERMS_CONDITIONS_INIT,
} from '../constants';

export function openMeetingRoomModal(link) {
  return async dispatch => {
    dispatch({
      type: OPEN_MEETINGROOM_MODAL,
      payload: link,
    });
  };
}

export function closeMeetingRoomModal() {
  return async dispatch => {
    dispatch({
      type: CLOSE_MEETINGROOM_MODAL,
    });
  };
}

export function openRoomSelectPopupModal(value) {
  return async dispatch => {
    dispatch({
      type: OPEN_ROOMSELECT_POPUP_MODAL,
      dataPopup: value,
    });
  };
}

export function closeRoomSelectPopupModal() {
  return async dispatch => {
    dispatch({
      type: CLOSE_ROOMSELECT_POPUP_MODAL,
    });
  };
}

export function termsConditionsInit(data) {
  return async dispatch => {
    dispatch({
      type: TERMS_CONDITIONS_INIT,
      payload: data,
    });
  };
}
